import { render } from "./ChartBlock.vue?vue&type=template&id=b7fe60bc&scoped=true"
import script from "./ChartBlock.vue?vue&type=script&lang=js"
export * from "./ChartBlock.vue?vue&type=script&lang=js"

import "./ChartBlock.vue?vue&type=style&index=0&id=b7fe60bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7fe60bc"]])

export default __exports__